/**
 * Pagination.
 *
 * Keyset (cursor) pagination rather than offset. Financial lists are append-
 * heavy and long-lived: offset pagination silently skips or repeats rows when
 * data is inserted mid-scan, and degrades badly past a few thousand rows. A
 * bookkeeper paging through two years of transactions must see every row
 * exactly once.
 */
export const DEFAULT_PAGE_SIZE = 25;
export const MAX_PAGE_SIZE = 100;
export function clampPageSize(requested) {
    if (requested === undefined || !Number.isFinite(requested))
        return DEFAULT_PAGE_SIZE;
    return Math.min(Math.max(Math.trunc(requested), 1), MAX_PAGE_SIZE);
}
/**
 * Builds a page from a slice fetched with `limit + 1` rows.
 *
 * Fetching one extra row is how `hasMore` is determined without a second COUNT
 * query, which on a large ledger is the expensive part.
 */
export function buildPage(rows, limit, toCursor) {
    const hasMore = rows.length > limit;
    const items = hasMore ? rows.slice(0, limit) : rows;
    const last = items.at(-1);
    return {
        items,
        hasMore,
        nextCursor: hasMore && last !== undefined ? toCursor(last) : null,
    };
}
/**
 * Cursors are opaque to clients. Encoding them prevents callers from building
 * their own, which would freeze our sort keys into the public API forever.
 */
export function encodeCursor(value) {
    return Buffer.from(value, 'utf8').toString('base64url');
}
export function decodeCursor(cursor) {
    return Buffer.from(cursor, 'base64url').toString('utf8');
}
//# sourceMappingURL=pagination.js.map